"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./BuiltForManySection.css";

const icons = [
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="use-case-icon">
    <rect x="6" y="10" width="36" height="30" rx="2" stroke="#1a1a2e" strokeWidth="2" />
    <path d="M6 18h36" stroke="#1a1a2e" strokeWidth="2" />
    <path d="M16 6v8M32 6v8" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
    <rect x="12" y="24" width="8" height="6" rx="1" stroke="#1a1a2e" strokeWidth="1.5" />
    <rect x="28" y="24" width="8" height="6" rx="1" stroke="#1a1a2e" strokeWidth="1.5" />
  </svg>,

  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="use-case-icon">
    <circle cx="18" cy="16" r="5" stroke="#1a1a2e" strokeWidth="2" />
    <circle cx="32" cy="14" r="4" stroke="#1a1a2e" strokeWidth="2" />
    <path d="M6 36c0-6 5-10 12-10s12 4 12 10" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 22c4 0 8 3 8 8" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
    <path d="M28 38l3 3 6-7" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,

  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="use-case-icon">
    <circle cx="24" cy="18" r="7" stroke="#1a1a2e" strokeWidth="2" />
    <path d="M10 40c0-7.7 6.3-14 14-14s14 6.3 14 14" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 22l4 4M36 22l-4 4" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
    <circle cx="36" cy="24" r="6" stroke="#1a1a2e" strokeWidth="1.5" />
    <path d="M34 24h4M36 22v4" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
  </svg>,

  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="use-case-icon">
    <rect x="8" y="12" width="22" height="16" rx="2" stroke="#1a1a2e" strokeWidth="2" />
    <path d="M30 20l8-5v14l-8-5" stroke="#1a1a2e" strokeWidth="2" strokeLinejoin="round" />
    <path d="M14 34v4M22 34v4M10 38h18" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
  </svg>,
];

export default function BuiltForManySection() {
  const { t } = useTranslation("landingPage");

  useRevealOnScroll();

  const useCasesRaw = t("builtFor.useCases", { returnObjects: true });
  const useCases = Array.isArray(useCasesRaw) ? useCasesRaw : [];

  if (!useCases.length) {
    return null;
  }

  return (
    <section className="bfm-section">
      <div className="bfm-container">
        <p className="bfm-label reveal-on-scroll reveal-up">
          {t("builtFor.label")}
        </p>

        <h2 className="bfm-heading reveal-on-scroll reveal-up">
          {t("builtFor.title.part1")}{" "}
          <span className="bfm-heading-accent">
            {t("builtFor.title.accent")}
          </span>
        </h2>

        <div className="bfm-grid">
          {useCases.map((uc, i) => (
            <div
              className="bfm-card reveal-on-scroll reveal-card"
              key={i}
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="bfm-icon-wrapper">{icons[i]}</div>
              <h3 className="bfm-card-title">{uc.title}</h3>
              <p className="bfm-card-desc">{uc.description}</p>
            </div>
          ))}
        </div>

        <div className="bfm-cta-wrapper reveal-on-scroll reveal-up">
          <button className="bfm-cta-btn" type="button">
            {t("common.getStarted")}
            <span className="bfm-cta-arrow">↗</span>
          </button>
        </div>
      </div>
    </section>
  );
}